<template>
  <div class="footer">
    <div :class="{ prizefoot: !footTxt, forumfoot: footTxt }">
      {{
        footTxt == ""
          ? "©FuturePrize.org 未来科学大奖主办单位&nbsp;京ICP备16046684号-1"
          : footTxt
      }}
      <div class="share">
        <img
          class="ecode"
          width="100%"
          height="auto"
          :src="require('../assets/weixin.jpg')"
          v-show="show"
        />
        <a
          href="javascript:;"
          class="weixin"
          @click="show = !show"
          @mouseenter="show = true"
          @mouseout="show = false"
        >
        </a>
        <a href="http://weibo.com/futureforum?source=blog" class="weibo"></a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  computed: {
    footTxt() {
      return this.$store.state.footTxt;
    },
  },
  watch: {
    show(newVal) {
      console.log(newVal);
    },
  },
  created() {
    console.log(this.$store.state.footTxt);
  },
  methods: {
  
  },
};
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  border-top: 0.1rem solid #ececec;
  background: #f6f4f5;

  .prizefoot {
    display: flex;
    justify-content: space-between;
    height: 3.2rem;
    font-size: 1rem;
    color: #999999;
    margin-left: 2.1rem;
    height: 3.2rem;
    line-height: 3.2rem;
    position: relative;
  }
  .forumfoot {
    display: flex;
    justify-content: space-between;
    height: 3.2rem;
    font-size: 1rem;
    color: #999999;
    margin: 1.1rem 0rem 0rem 2.1rem;
    height: 3.2rem;
    line-height: 3.2rem;
    overflow: hidden;
  }
  .share {
    // position: relative;
    width: 8.6rem;
    height: 3.2rem;
    display: flex;

    .ecode {
      position: absolute;
      right: 5rem;
      bottom: 3rem;
      width: 6rem;
    }

    a {
      display: block;
      width: 2.56rem;
      height: 2.56rem;
      margin-top: 0.35rem;
      margin-right: 0.85rem;
    }
    .weibo {
      background: url("../assets/weibo1.png") center no-repeat;
      background-size: 80% 85%;
    }

    .weixin {
      background: url("../assets/weixin.png") center no-repeat;
      background-size: 80% 85%;
    }
  }
}

@media (max-width: 768px) {
  .footer {
    .prizefoot {
      transform: scale(0.9);

      .share {
        display: none;
      }
    }
    .ecode {
      bottom: 3rem!important;
    }
    .forumfoot {
      height: 7rem;
      font-size: 1rem;
      color: #999999;
      line-height: 1.9rem;
      .share {
        position: absolute;
        right: 0rem;
        margin-top: 3.3rem;
      }
    }
  }
}
</style>